import React from "react";
import { IAddUpdateCustomerPageState, IAgentManagementPageProps } from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";
import AddUpdateAgentManagementPage from "./AddUpdateAgentManagementPage";
import AgentManagementList from "./AgentManagementList";

export default class AgentManagementPage extends React.Component<IAgentManagementPageProps, IAddUpdateCustomerPageState> {
  constructor(props: IAgentManagementPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedAgentManagementUser: null,
      isAgentManagementUserAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
      passwordReset: "",
    };
  }

  renderAddUpdateAgentManagementPage = () => {
    const { isEdit, selectedAgentManagementUser, searchText } = this.state;
    const {
      getUpdateAgentDetail,
      agentManagementUserDetails,
      isLoading,
      isError,
      error,
      getAllAgentZones,
      allAgentZones,
      isAllAgentZonesFetched,
      createAgentWithTypeTeamZones,
      createAgentUserWithTypeTeamZones,
      updateAgentUserWithTypeTeamZones,
      userInfo,
      fetchAgentTitle,
      agentTitle,
      fetchAgentTeam,
      agentTeam,
      fetchBrands,
      brands,
      fetchCustomerConfig,
      customerConfig,
      getBulkCustomerDetailsByIdAction,
      clearBulkCustomerDetailsAction,
      bulkCustomerDetails,
      isBulkCustomerDetailsFetched,
      fetchCities,
      citiesList,
      isCityListFetched,
    } = this.props;
    return (
      <AddUpdateAgentManagementPage
        {...this.props}
        selectedAgentManagementUser={selectedAgentManagementUser}
        isEdit={isEdit}
        getUpdateAgentDetail={getUpdateAgentDetail}
        backButtonHandler={this.navigateBackToListingPage}
        agentManagementUserDetails={agentManagementUserDetails}
        isLoading={isLoading}
        isError={isError}
        error={error}
        getAllAgentZones={getAllAgentZones}
        allAgentZones={allAgentZones}
        isAllAgentZonesFetched={isAllAgentZonesFetched}
        createAgentTeamZone={createAgentWithTypeTeamZones}
        createAgentTitleTeamZone={createAgentUserWithTypeTeamZones}
        updateAgentTitleTeamZone={updateAgentUserWithTypeTeamZones}
        userInfo={userInfo}
        fetchAgentTitle={fetchAgentTitle}
        agentTitle={agentTitle}
        fetchAgentTeam={fetchAgentTeam}
        agentTeam={agentTeam}
        fetchBrands={fetchBrands}
        brands={brands}
        fetchCustomerConfig={fetchCustomerConfig}
        customerConfig={customerConfig}
        getBulkCustomerDetailsByIdAction={getBulkCustomerDetailsByIdAction}
        clearBulkCustomerDetailsAction={clearBulkCustomerDetailsAction}
        bulkCustomerDetails={bulkCustomerDetails}
        isBulkCustomerDetailsFetched={isBulkCustomerDetailsFetched}
        fetchCities={fetchCities}
        citiesList={citiesList}
        isCityListFetched={isCityListFetched}
        searchText={searchText}
      />
    );
  };

  renderAgentManagementUserListing = () => {
    const { getAgentList, agentManagementUsers, error, pagination, isAgentManagementUserAdded, isAgentManagementUserUpdated, isLoading, isError, userInfo } = this.props;
    const { isAgentManagementUserAddUpdate, searchText, currentListPosition, passwordReset } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Agent Management" isMainHeading={true} />
        </section>
        <AgentManagementList
          getAgentList={getAgentList}
          agentManagementUsers={agentManagementUsers}
          pagination={pagination}
          isLoading={isLoading}
          isError={isError}
          error={error}
          isAgentManagementUserAddedorUpdated={isAgentManagementUserAddUpdate}
          addUpdatePageHandler={this.toggleAddUpdateAgentManagementUserPage}
          isAgentManagementUserAdded={isAgentManagementUserAdded}
          isAgentManagementUserUpdated={isAgentManagementUserUpdated}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
          userInfo={userInfo}
          passwordReset={passwordReset}
        />
      </>
    );
  };

  toggleAddUpdateAgentManagementUserPage = (isEdit: boolean = false, selectedAgentManagementUser: any = null, searchText: string = "", currentScroll: number = 0) => {
    const { showAddUpdatePage } = this.state;
    if (selectedAgentManagementUser) {
      selectedAgentManagementUser = {
        ...selectedAgentManagementUser,
        customerChannel: {
          id: selectedAgentManagementUser.customerChannel,
          title: selectedAgentManagementUser.customerChannel,
          value: selectedAgentManagementUser.customerChannel,
          label: selectedAgentManagementUser.customerChannel,
        },
      };
    }
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedAgentManagementUser: selectedAgentManagementUser,
      searchText: searchText,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean, passwordReset: any) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isAgentManagementUserAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
      passwordReset: passwordReset,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return <div>{showAddUpdatePage ? this.renderAddUpdateAgentManagementPage() : this.renderAgentManagementUserListing()}</div>;
  }
}
